import { render, staticRenderFns } from "./OffboardingUser.vue?vue&type=template&id=16251ba9"
import script from "./OffboardingUser.vue?vue&type=script&lang=js"
export * from "./OffboardingUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports